/**
 * API Key 列表 Hook：基于通用 useApi 的轻量封装。
 *
 * @module hooks/useApiKeys
 */
import type { ApiKey } from '@/types';
import { listApiKeys } from '@/services/apikey';
import { useApi, type UseApiResult } from './useApi';

/**
 * API Key 列表 Hook。
 *
 * @returns 通用请求状态（data 为 ApiKey[]）。
 */
export function useApiKeys(): UseApiResult<ApiKey[]> {
  return useApi<ApiKey[]>(() => listApiKeys());
}
